import { createContext, ReactNode, useContext, useState } from "react";
import { FilterOption, FilterState } from "@/models";
import { CalendarIcon, DollarIcon, MethodIcon, StatusIcon } from "@/styles/icons";
interface ChargeFilterProps {
  children: ReactNode;
}

interface SearchTypeOptionProps {
    label: string;
    value: string;
}
interface ChargeFilterContextData {
    filterState: FilterState;
    setFilterState: React.Dispatch<React.SetStateAction<FilterState>>;
    clearFilterState: FilterState;
    searchTypeOptions: SearchTypeOptionProps[];
    filterOptions: FilterOption[];
    searchType: string;
    searchTerm: string;
    hasAppliedFilters: boolean;
    currentPage: number;
    setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
    setSearchType: React.Dispatch<React.SetStateAction<string>>;
    setHasAppliedFilters: React.Dispatch<React.SetStateAction<boolean>>;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}



const ChargeFilterContext = createContext<ChargeFilterContextData>(
  {} as ChargeFilterContextData
);

const ChargeFilterProvider = ({ children }: ChargeFilterProps) => {
    const clearFilterState = {
      status: "ALL",
      customerName: null,
      customerDocument: null,
      customerEmail: null,
      title: null,
      expirationDateInitial: null,
      expirationDateFinal: null,
      paidDateInitial: null,
      paidDateFinal: null,
      paymentLink: null,
      valueMin: null,
      valueMax: null,
      paymentMethod: null,
      page: 1
    }
    const [filterState, setFilterState] = useState<FilterState>({} as FilterState);
    const [hasAppliedFilters, setHasAppliedFilters] = useState(false);
    const filterOptions: FilterOption[] = [
        { 
          icon: <CalendarIcon size={12} />,
          id: "data-pagamento", 
          label: "Data de pagamento", 
          type: "date" 
        },
        { 
          icon: <CalendarIcon size={12} />,
          id: "data-vencimento", 
          label: "Data de vencimento", 
          type: "date" 
        },
        { 
          icon: <DollarIcon size={12} />,
          id: "valor", 
          label: "Valor", 
          type: "range" 
        },
        {
          icon: <StatusIcon size={12} />,
          id: "status",
          label: "Status",
          options: [
            { label: "Todas", value: "ALL" },
            { label: "Pagas", value: "PAID" },
            { label: "Pré Autorização", value: "PRE_AUTHORIZED" },
            { label: "Agendadas", value: "SCHEDULED" },
            { label: "Atrasadas", value: "LATE" },
            { label: "Canceladas", value: "CANCELED" },
            { label: "Desistência", value: "ABANDONED" },
            { label: "Estornadas", value: "CHARGEBACK" },
            { label: "Erro", value: "FAILED" },
          ]
        },
        {
          icon: <MethodIcon size={12} />,
          id: "paymentMethod",
          label: "Método de pagamento",
          options: [
            { label: "Todos",  value: "ALL" },
            { label: "Cartão", value: "CREDIT_CARD" },
            { label: "Boleto", value: "BANK_SLIP" },
            { label: "Pix", value: "PIX" }
          ]
        },
    ]
    const [searchType, setSearchType] = useState("customerName");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const searchTypeOptions: SearchTypeOptionProps[] = [
        { label: "Cliente", value: "customerName" },
        { label: "CPF/CNPJ", value: "customerDocument" },
        { label: "Email", value: "customerEmail" },
        { label: "Título da Cobrança", value: "title" },
        { label: "ID - Link de pagamento", value: "paymentLink" }
    ];
    
    return (
        <ChargeFilterContext.Provider
            value={{
                filterState,
                setFilterState,
                clearFilterState,
                searchTypeOptions,
                filterOptions,
                searchType,
                searchTerm,
                hasAppliedFilters,
                currentPage,
                setSearchTerm,
                setSearchType,
                setHasAppliedFilters,
                setCurrentPage,
            }}
        >
            {children}
        </ChargeFilterContext.Provider>
    );
    };

export function useChargeFilter(): ChargeFilterContextData {
  return useContext(ChargeFilterContext);
}

export { ChargeFilterProvider };
